import React from 'react'
import OneAuthWrapper from './OneAuthWrapper'

const ProtectedRoute: React.FunctionComponent<any> = ({
  component,
  ...args
}) => {
  return <OneAuthWrapper Component={component} {...args} />
}

export default ProtectedRoute
